import { getCurrentInstance, ref, useStore, computed } from "@nuxtjs/composition-api";
import useMessage from "~/composables/useMessage";
import { REQUEST_CODES } from "~/constants/const-http";
import { updateAisCruiseCollectionStatus } from "~/services/company";
export default function useFavorite() {
    const isFavorite = ref(false);
    const Message = useMessage()
    const iconClass = computed(() => isFavorite.value ? 'ficon ficon-Union' : 'ficon ficon-a-Star16Stroke')
    async function toggleFavorite(cruise_id) {

        const { code, msg } = await updateAisCruiseCollectionStatus({ cruise_id })
        if (code !== REQUEST_CODES.ERROR_OK) {
            Message.error(msg)
            throw new Error(msg)
        }

        isFavorite.value = !isFavorite.value;
        Message.success(`${isFavorite.value ? '收藏' : '取消收藏'}成功`)
    }
    
    return {
        isFavorite,
        toggleFavorite,
        iconClass
    }
}